var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('pageHeader'),_c('router-view'),(_vm.$root.showSystemStop)?_c('SystemStop',{attrs:{"systemInfo":_vm.$root.systemInfo},on:{"close":function($event){_vm.$root.showSystemStop = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }